import { createSlice } from '@reduxjs/toolkit';
import * as config from '../../config.js';

const initialState = {
  colors : [],
  lastUrl : "",
  imgUrl : ""
};
let nextColorId = 0;

export const colorSlice = createSlice({
  name: 'color',
  initialState,
  reducers: {
    //FOR TEST
    addColor: {
      reducer(state, action) {
        const { id, color } = action.payload;
        // state.lastUrl = "https://source.unsplash.com/random/200x200?sig="+id;
        state.colors.push({ id, color, checked: false, "preview-image-url":"https://picsum.photos/200/300?random="+id })
        state.lastUrl = "https://picsum.photos/200/300?random="+id;
      },
      prepare(color) {
        return { payload: { color : color, id: ++nextColorId } }
      }
    },
    addColors(state, action) {
      const colors = action.payload;
      colors.forEach(col => {
        col.checked = false;
        col.groupIdx = null;
        col["preview-image-url"] = config.SERVER_API + col["preview-image-url"]
      });
      state.colors = colors;
      nextColorId = colors.length - 1;
    },
    toggleColor: {
      reducer(state, action) {
        const { colorId, groupIdx } = action.payload;
        const color = state.colors.find(color => color.id === colorId)
        if (color) {
          color.checked = !color.checked;
          state.lastUrl = color["preview-image-url"];
          if(color.checked){
            color.groupIdx = groupIdx;
          }else{
            color.groupIdx = null;
          }
        }
        
      },
      prepare(data) {
        return { payload: { colorId : data.colorId, groupIdx: data.groupIdx } }
      }
    },
    clearAllColor(state){
      state.colors = [];
      state.lastUrl = "";
      state.imgUrl = "";
    },
    setLastUrl (state, action) {
      const color = state.colors.find(color => color.id === action.payload);
      state.lastUrl = color["preview-image-url"];
    },
    clearLastUrl (state, action) {
      state.lastUrl = action.payload;
    },
    setImgUrl (state, action) {
      state.imgUrl = action.payload;
    }
  }
});

export const { 
  increment, 
  testDecrement, 
  addColor, 
  toggleColor, 
  addColors, 
  setLastUrl, 
  clearLastUrl,
  clearAllColor
} = colorSlice.actions;
export const selectColor = (state) => state.color.colors;
export const getLastUrl= (state) => state.color.lastUrl;

export default colorSlice.reducer;
